import angularModule from 'LearnerProjects/angularModule/scripts/learner_projects_module';

angularModule.factory('LearnerProject', [
    '$injector',
    $injector => {
        const Iguana = $injector.get('Iguana');

        return Iguana.subclass(function () {
            this.setCollection('learner_projects');
            this.alias('LearnerProject');
            this.setIdProperty('id');

            this.CAPSTONE_PROJECT_TYPE = 'capstone';
            this.STANDARD_PROJECT_TYPE = 'standard';
            this.PRESENTATION_PROJECT_TYPE = 'presentation';

            // EMBA/MBA current - duplicated on server model
            this.PASSING_SCORES_MAP = {
                capstone: 3,
                standard: 2,
                presentation: 2,
            };

            Object.defineProperty(this.prototype, 'titleWithTag', {
                get() {
                    return this.tag ? `${this.title} [${this.tag}]` : this.title;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'sortKey', {
                get() {
                    const matches = (this.tag && this.tag.match(/[0-9]+/)) || ['0'];
                    const tagNumber = matches[0];
                    return `${this.title}${tagNumber.padStart(4, 0)}`;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'isCapstoneProject', {
                get() {
                    return this.project_type === this.constructor.CAPSTONE_PROJECT_TYPE;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'isStandardProject', {
                get() {
                    return this.project_type === this.constructor.STANDARD_PROJECT_TYPE;
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'isPresentationProject', {
                get() {
                    return this.project_type === this.constructor.PRESENTATION_PROJECT_TYPE;
                },
                configurable: true,
            });

            // Check if this project accepts presentation link submissions
            // (different from isPresentationProject which checks project_type)
            Object.defineProperty(this.prototype, 'hasPresentationLinkFormat', {
                get() {
                    const formats = this.submission_formats;
                    if (!formats || !Array.isArray(formats)) return false;
                    return formats.some(f => f.type === 'presentation_link');
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'validStatusOptionsForProgressRecords', {
                get() {
                    if (this.isPresentationProject) {
                        // The video_presentation_submitted and live_presentation_* values have been
                        // consolidated into 'submitted' (see https://trello.com/c/gWYbEz4l).
                        return [
                            {
                                value: 'submitted',
                                label: 'submitted',
                            },
                        ];
                    }

                    return [
                        {
                            value: 'submitted',
                            label: 'submitted',
                        },
                        {
                            value: 'plagiarized',
                            label: 'plagiarized',
                        },
                    ];
                },
                configurable: true,
            });

            return {
                // duplicated on server model, varies between EMBA and MBA
                getScoringWeight(cohort) {
                    if (this.isCapstoneProject) {
                        return 4;
                    }
                    if (this.isStandardProject) {
                        return cohort.isMBA && cohort.startDate < new Date('2021/08/09') ? 4 : 2;
                    }
                    if (this.isPresentationProject) {
                        return 1;
                    }
                    return undefined;
                },

                // duplicated on server model
                getPassingScore(cohort) {
                    // Standard projects can have varying passing scores, dependent on the
                    // cohort's program_type and start_date
                    if (
                        this.isStandardProject &&
                        ((cohort.program_type === 'emba' && cohort.startDate <= new Date('2019/07/01')) ||
                            (cohort.program_type === 'mba' && cohort.startDate <= new Date('2019/07/29')))
                    ) {
                        return 1;
                    }
                    return this.constructor.PASSING_SCORES_MAP[this.project_type];
                },

                addProjectDocument(projectDocument) {
                    // Default the title
                    projectDocument.title = projectDocument.file_file_name;
                    this.project_documents.push(projectDocument);
                },

                removeProjectDocument(projectDocument) {
                    this.project_documents = (this.project_documents || []).filter(
                        document => document !== projectDocument,
                    );
                },

                addPrivateProjectDocument(projectDocument) {
                    // Default the title
                    projectDocument.title = projectDocument.file_file_name;
                    this.private_project_documents = this.private_project_documents || [];
                    this.private_project_documents.push(projectDocument);
                },

                removePrivateProjectDocument(projectDocument) {
                    this.private_project_documents = (this.private_project_documents || []).filter(
                        document => document !== projectDocument,
                    );
                },
            };
        });
    },
]);
